import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    width: "100%",
    height: "10em",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0px -2px 0px #DEE4EB",
    backgroundColor: "#ececec",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  imageContainer: {
    display: "grid",
    placeItems: "center",
    width: 144,
    height: 144,
    boxSizing: "border-box",
    margin: theme.spacing(0, 2),
    border: "2px solid transparent",
  },
  activeImage: {
    border: `2px solid ${theme.palette.secondary.main}`,
  },
  image: {
    boxSizing: "border-box",
    cursor: "pointer",
    width: 140,
    height: 140,
    "& > img": {
      width: "100%",
      height: "100%",
      objectFit: "contain",
    },
  },
}));
